export const getIndividualMember = (Id = undefined, email = undefined) => {
  if (!(Id || email)) {
    return null;
  }

  return `
        SELECT
          Id,
          Canal_de_atendimento__c,
          Status__c,
          Name__c,
          Name__r.Profile.Name,
          Mesa_Opera_o__r.Name,
          Mesa_Opera_o__r.Id,
          Mesa_Opera_o__r.Lider__c,
          Mesa_Opera_o__r.Lider__r.Nome_do_Outlook__c,
          Mesa_Opera_o__r.Lider__r.Email_do_Salesforce__c,
          Mesa_Opera_o__r.Lider__r.Name,
          Nome_do_outlook__c,
          Nivel_do_Ecossistema__c,
          LOP_Group__c,
          Canal_LOP__c,
          Email_do_Salesforce__c,
          Time__c
        FROM
          Membros__c
        WHERE
          ${Id ? `Id = '${Id}'` : ''}
          ${email ? `Email_do_Salesforce__c = '${email}'` : ''}
        LIMIT 1
      `;
};
